import React, { Component } from 'react'
//import {Link} from 'gatsby'
import Layout from '../components/layout'
import Head from '../components/head'
import AboutMe from '../components/aboutMe'
import * as aboutStyle from './pageStyles/about-style.module.scss'

export default class AboutPage extends Component {

    render() {
        return (
            <Layout>
                <Head title="About" />
                <div className={aboutStyle.content}>
                    <AboutMe/>
                </div>
            </Layout>
        )
    }
}


